__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.2.2-02212026/_next/";